export const hubUrls = {
  // Pile Turner
  getPileTurnerInfo: (pileTurnerId: number) => `/PileTurner/${pileTurnerId}`
};
